"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossiblePersonalAutoDiscountType = exports.PersonalAutoCombinedDiscountTypes = exports.PersonalAutoDiscountTypes = void 0;
const zod_1 = require("zod");
const CommonDiscountTypes_1 = require("../enums/CommonDiscountTypes");
const PersonalAutoDiscounts_1 = require("../enums/PersonalAutoDiscounts");
exports.PersonalAutoDiscountTypes = Object.assign({}, PersonalAutoDiscounts_1.PersonalAutoDiscounts, CommonDiscountTypes_1.CommonDiscounts);
exports.PersonalAutoCombinedDiscountTypes = {
    [exports.PersonalAutoDiscountTypes.COMBINED_GOOD_DRIVER_SAFETY_COURSE]: [
        exports.PersonalAutoDiscountTypes.GOOD_DRIVER,
        exports.PersonalAutoDiscountTypes.SAFETY_COURSE,
    ],
};
exports.impossiblePersonalAutoDiscountType = zod_1.z.union([zod_1.z.nativeEnum(PersonalAutoDiscounts_1.PersonalAutoDiscounts), zod_1.z.nativeEnum(CommonDiscountTypes_1.CommonDiscounts)]);
